import { render } from "./close.vue?vue&type=template&id=abc6303c&scoped=true"
import script from "./close.vue?vue&type=script&lang=js"
export * from "./close.vue?vue&type=script&lang=js"

import "./close.vue?vue&type=style&index=0&id=abc6303c&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abc6303c"]])

export default __exports__